import type { IEmployeeTalkState } from '@sharedInterfaces/IEmployeeTalkState';
import { useCallback } from 'react';

export const useEmployeeTalkAnalysis = (talkState: IEmployeeTalkState | null) => {
    const getAnalysisData = useCallback(
        (field: 'skills' | 'certificates' | 'roles' | 'description'): unknown => {
            return talkState?.analysis[field]?.data;
        },
        [talkState],
    );

    const isAnalysisComplete = useCallback((): boolean => {
        if (!talkState?.analysis) return false;
        return Object.entries(talkState.analysis).every(([key, field]) => {
            if (key === 'started' || key === 'attachmentId') return true; // Skip non-field properties
            if (typeof field === 'string' || typeof field === 'boolean') return true;
            return field.status === 'completed' || field.status === 'idle';
        });
    }, [talkState]);

    return { getAnalysisData, isAnalysisComplete };
};
